import { colors } from "Constants";

const styles = {
  avatarStyle: {
    randomizeColor: true,
    shade: "light",
    size: "medium",
  },
  linkStyle: {
    cursor: "default",
  },
  subTextStyle: {
    color: colors.textSubtle,
  },
};

export default styles;
